import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import StoreCreditList from './StoreCreditList'

const StoreCreditInfos = ({ storeCredits }) => {
    return (
        <TableContainer component={Paper}>
            <Table aria-label="simple table">
                <TableHead>
                    <TableRow>
                        <TableCell>Customer</TableCell>
                        <TableCell>Pay Type</TableCell>

                        <TableCell>Credit Amount</TableCell>
                        <TableCell>Date</TableCell>
                        <TableCell>Confirm</TableCell>
                        <TableCell style={{ width: '50px' }}></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {storeCredits?.map((storeCredit) => (
                        <StoreCreditList
                            storeCredit={storeCredit}
                            key={storeCredit.id}
                        />
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    )
}

export default StoreCreditInfos
